<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel class="eca-card">
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="row" style="padding: 5px!important ; width:100% !important;">
        <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
          <div class="d-flex align-items-center">
            <h3 style="margin-bottom: 0 !important;" class="list-page-main-header">
              <span><fa-icon [icon]="['fad', 'users']"> </fa-icon> Upload new Operatives </span>
            </h3>
          </div>
        </div>
      </div>
    </ng-template>
    
    <div *ngIf="loading" class="text-center">
      <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
    </div>
    <div>
      Please use the provided template. Click the button below to download.
      <br />
      <button type="button" pButton class="relative waves-light" (click)="templateButtonUrl()"><i [ngClass]="[uploadButtonIcon, 'eca-btn-' + uploadButtonColor]" *ngIf="uploadButtonIcon"></i> {{templateButtonText}}</button>
    </div>
    <br />
    <div *ngIf="!loading">
      <operative-upload-form [documentSummary]="tempDocumentSummary" [saveAttempted]="saveAttempted"
                             [submitted]="saveAttempted"
                             (fileUpload)="fileUploaded($event)"
                             (fileRemove)="removeFile($event)"></operative-upload-form>

      <button type="button" pButton class="relative waves-light" (click)="clicked(true)" [disabled]="!formIsValid"><i [ngClass]="[uploadButtonIcon, 'eca-btn-' + uploadButtonColor]" *ngIf="uploadButtonIcon"></i> {{uploadButtonText}}</button>
    </div>
  </p-panel>
</div>
